document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.getElementById('debug-console-wrapper');

  if (!wrapper) {
    console.log('Debug console wrapper não encontrado');
    return;
  }

  // Elementos
  const toggleBtn = document.getElementById('debug-toggle');
  const debugConsole = document.getElementById('debug-console');
  const closeBtn = document.getElementById('debug-close');
  const clearBtn = document.getElementById('debug-clear');
  const minimizeBtn = document.getElementById('debug-minimize');
  const maximizeBtn = document.getElementById('debug-maximize');
  const tabs = document.querySelectorAll('.debug-tab');
  const tabContents = document.querySelectorAll('.debug-tab-content');
  const consoleInput = document.getElementById('console-input');
  const consoleOutput = document.getElementById('console-output');

  // Estado
  let commandHistory = [];
  let historyIndex = -1;

  // Toggle visibility
  if (toggleBtn && debugConsole) {
    toggleBtn.addEventListener('click', () => {
      debugConsole.style.display = 'flex';
      toggleBtn.style.display = 'none';
      if (consoleInput) consoleInput.focus();
    });
  }

  if (closeBtn && debugConsole && toggleBtn) {
    closeBtn.addEventListener('click', () => {
      debugConsole.style.display = 'none';
      toggleBtn.style.display = 'block';
    });
  }

  // Clear
  if (clearBtn && consoleOutput) {
    clearBtn.addEventListener('click', () => {
      consoleOutput.innerHTML = '';
      addConsoleLog('Console limpo', 'console-system');
    });
  }

  // Minimize/Maximize
  if (minimizeBtn) {
    minimizeBtn.addEventListener('click', () => {
      debugConsole.classList.toggle('minimized');
    });
  }

  if (maximizeBtn) {
    maximizeBtn.addEventListener('click', () => {
      debugConsole.classList.toggle('maximized');
    });
  }

  // Tabs
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const targetTab = tab.dataset.tab;

      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      tabContents.forEach(content => {
        content.classList.remove('active');
        if (content.id === `tab-${targetTab}`) {
          content.classList.add('active');
        }
      });
    });
  });

  // Input do console
  if (consoleInput) {
    consoleInput.addEventListener('keydown', async (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        const command = consoleInput.value.trim();

        if (command) {
          commandHistory.push(command);
          historyIndex = commandHistory.length;

          addConsoleLog(`>> ${command}`, 'console-command');
          consoleInput.value = '';

          await executeCommand(command);
        }
      }

      // Histórico
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (historyIndex > 0) {
          historyIndex--;
          consoleInput.value = commandHistory[historyIndex];
        }
      }

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (historyIndex < commandHistory.length - 1) {
          historyIndex++;
          consoleInput.value = commandHistory[historyIndex];
        } else {
          historyIndex = commandHistory.length;
          consoleInput.value = '';
        }
      }
    });
  }

  // Executa comando
  async function executeCommand(command) {
    try {
      // Token CSRF
      const tokenMeta = document.querySelector('meta[name="csrf-token"]');
      const token = tokenMeta ? tokenMeta.getAttribute('content') : null;

      console.log('Executando comando:', command);

      // Requisição com .json na URL para forçar formato
      const response = await fetch('/debug_console/execute.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          ...(token && { 'X-CSRF-Token': token })
        },
        body: JSON.stringify({ command: command })
      });

      console.log('Status:', response.status);
      console.log('Content-Type:', response.headers.get('content-type'));

      // Lê resposta como texto primeiro
      const responseText = await response.text();
      console.log('Resposta:', responseText.substring(0, 200));

      // Tenta fazer parse do JSON
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (parseError) {
        console.error('Erro ao fazer parse do JSON:', parseError);

        // Se não for JSON, mostra erro
        if (responseText.includes('<!DOCTYPE')) {
          addConsoleLog('Erro: Servidor retornou HTML ao invés de JSON', 'console-error');
          addConsoleLog('Verifique o controller e as rotas', 'console-error');
        } else {
          addConsoleLog('Erro: Resposta inválida do servidor', 'console-error');
        }
        return;
      }

      // Processa resposta
      if (data.success) {
        if (data.action === 'clear') {
          consoleOutput.innerHTML = '';
          addConsoleLog('Console limpo', 'console-system');
        } else {
          // Mostra resultado linha por linha
          const lines = (data.result || '').toString().split('\n');
          lines.forEach((line, index) => {
            if (line) {
              addConsoleLog(
                index === 0 ? `=> ${line}` : `   ${line}`,
                'console-result'
              );
            }
          });

          // Mostra classe se não for string básica
          if (data.class && !['String', 'NilClass'].includes(data.class)) {
            addConsoleLog(`   (${data.class})`, 'console-class');
          }
        }
      } else {
        addConsoleLog(`Erro: ${data.error}`, 'console-error');

        if (data.backtrace && Array.isArray(data.backtrace)) {
          data.backtrace.forEach(line => {
            addConsoleLog(`  ${line}`, 'console-backtrace');
          });
        }
      }

    } catch (error) {
      console.error('Erro na execução:', error);
      addConsoleLog(`Erro: ${error.message}`, 'console-error');
      addConsoleLog('Verifique o console do navegador para mais detalhes', 'console-suggestion');
    }
  }

  // Adiciona log ao console
  function addConsoleLog(message, className) {
    if (!consoleOutput) return;

    const log = document.createElement('div');
    log.className = `console-log ${className}`;

    // Timestamp opcional
    if (!['console-system'].includes(className)) {
      const time = new Date().toLocaleTimeString('pt-BR');
      const timeSpan = document.createElement('span');
      timeSpan.className = 'console-timestamp';
      timeSpan.textContent = `[${time}] `;
      log.appendChild(timeSpan);
    }

    const messageSpan = document.createElement('span');
    messageSpan.textContent = message;
    log.appendChild(messageSpan);

    consoleOutput.appendChild(log);
    consoleOutput.scrollTop = consoleOutput.scrollHeight;
  }

  // Atalho Ctrl+D
  document.addEventListener('keydown', (e) => {
    if ((e.ctrlKey || e.metaKey) && e.key === 'd') {
      e.preventDefault();

      if (debugConsole && toggleBtn) {
        if (debugConsole.style.display === 'none' || !debugConsole.style.display) {
          debugConsole.style.display = 'flex';
          toggleBtn.style.display = 'none';
          if (consoleInput) consoleInput.focus();
        } else {
          debugConsole.style.display = 'none';
          toggleBtn.style.display = 'block';
        }
      }
    }
  });

  // Draggable
  let isDragging = false;
  let currentX = 0, currentY = 0;
  let initialX = 0, initialY = 0;
  let xOffset = 0, yOffset = 0;

  const header = debugConsole?.querySelector('.debug-header');

  if (header) {
    header.addEventListener('mousedown', dragStart);
    document.addEventListener('mousemove', drag);
    document.addEventListener('mouseup', dragEnd);
  }

  function dragStart(e) {
    if (e.target.closest('.debug-header-actions')) return;

    initialX = e.clientX - xOffset;
    initialY = e.clientY - yOffset;

    if (e.target === header || e.target.parentElement === header) {
      isDragging = true;
    }
  }

  function drag(e) {
    if (isDragging && debugConsole) {
      e.preventDefault();
      currentX = e.clientX - initialX;
      currentY = e.clientY - initialY;
      xOffset = currentX;
      yOffset = currentY;

      debugConsole.style.transform = `translate(${currentX}px, ${currentY}px)`;
    }
  }

  function dragEnd() {
    initialX = currentX;
    initialY = currentY;
    isDragging = false;
  }

  // Inicialização
  if (consoleOutput) {
    addConsoleLog('🚀 Console Rails Debug', 'console-system');
    addConsoleLog('Digite "help" para comandos disponíveis', 'console-system');
  }
});